import { useEffect, useState } from "react"
import { SortDirection } from "@/components/shared/Table/types"
import { sortByField } from "@/utils/index"
import { isNull } from "@/utils/lodash"

export function useTableSort<T extends { id: number | string }>(
   initialData: T[],
   initialSortField: keyof T | null
) {
   const [preventData, setPreventData] = useState<T[]>([])
   const [data, setData] = useState<T[]>(initialData)
   const [sortField, setSortField] = useState<keyof T | null>(null)
   const [sortDirection, setSortDirection] = useState<SortDirection | null>(
      null
   )

   useEffect(() => {
      if (initialData.length === 0) {
         setData(initialData)
         setPreventData([])
         return
      }

      const field = sortField ?? initialSortField
      const direction = sortDirection ?? SortDirection.ASC

      if (!isNull(field)) {
         const filteredData = initialData.filter((item) =>
            (item.id as string).includes("bulk-")
         )
         const restData = initialData.filter(
            (item) =>
               !filteredData.some((filteredItem) => filteredItem.id === item.id)
         )
         setPreventData(filteredData)
         setSortField(field)
         setSortDirection(direction)
         setData(sortByField(restData, field, direction))
      } else {
         setData(initialData)
      }
   }, [initialData, initialSortField, sortField, sortDirection])

   const handleSort = (field: keyof T) => {
      let newDirection = SortDirection.ASC
      if (sortField === field) {
         newDirection =
            sortDirection === SortDirection.DESC
               ? SortDirection.ASC
               : SortDirection.DESC
      }

      setSortField(field)
      setSortDirection(newDirection)
      setData(sortByField(data, field, newDirection))
   }

   return {
      data: [...data, ...preventData],
      sortField,
      sortDirection,
      handleSort,
      setData,
   }
}
